export default "__VITE_ASSET__u5gtEjxT__"